import React, { useState, useEffect,useImperativeHandle ,forwardRef} from "react";
import {
  Modal,
  Button,
  Space,
  Input,
  Form,
  Select,
  message,
  notification,
  Col,
  Row,
  Radio
} from "antd";
import { Table } from "antd";
import { SearchOutlined, EditFilled ,UserOutlined } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import { path, src } from "../network/conn";
const key = "updatable";
const openMessageLoading = (load) => {
  message.loading({ content: load, key });
};
const openMessageSuccess = (loaded) => {
  message.success({ content: loaded, key, duration: 2 });
};
const openNotification = (record) => {
  var code = record.productcode;
  const btn = (code) => {
    return (
      <Button
        type="primary"
        size="small"
        onClick={(code) => notification.close()}
      >
        Confirm
      </Button>
    );
  };

  notification.open({
    message: "Notification Title",
    description: "Are you Sure Want To Delete",
    key,
  });
};
const Masterpatient = forwardRef((Props,refpro) => {
  useImperativeHandle(refpro, () => ({
    handlePropsReload(){
      //fetchCategory();
      console.log('childprops');
    }
    }));
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setdataSource] = useState([]);
  const [size, setSize] = useState();
  const [totalRecord, settotalRecord] = useState(0);
  const [patientType, setpatientType] = useState("avatarMaleIcon");
  const [submitType, setsubmitType] = useState("insert");
  const [userSetting, setUserSetting] = useState({});
  const [form] = Form.useForm();
  const logUser = window.sessionStorage.getItem("user");

  const addProduct = () => {
    setsubmitType("insert");
    fetchCount();
    showLargeDrawer();
  };
  const showLargeDrawer = () => {
    setSize("large");
    setVisible(true);
  };
  const drawerClose = () => {
    setVisible(false);
    form.resetFields();
  };
  const { Option } = Select;
 

  const onFinish = (e) => {
    const data = e;
    data['user'] = logUser;
    openMessageLoading("Adding patient", 20);
    let BaseURL = path + src + "insertpatient.php";
    axios
      .post(BaseURL, data)
      .then((response) => {
        openMessageSuccess(response.data, 20);
        setVisible(false);
        drawerClose();
        fetchTableData();
        form.resetFields();
        Props.onScanDataPatiReload();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchTableData = () => {
    setLoading(true);
    let BaseURL = path + src + "patientlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        let filteredArr = response.data.sort((a,b)=>{return b.sno - a.sno});
        setdataSource(filteredArr);
        settotalRecord(response.data.length);
        setVisible(false);
        setLoading(false);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchPincode = (e) => {
    let pincode = e.target.value;
    let BaseURL = path + src + "pincode.php?pincode=" + pincode;
    axios
      .get(BaseURL)
      .then((response) => {
        form.setFieldsValue({
          district: response.data.district,
          state: response.data.state,
        });
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchCount = () => {
        let value = dataSource.length + 1 ; 
        let valueStr = "0000"+ value.toString();
        form.setFieldsValue({
          patientid: "ALPHA-" + (valueStr.substr(-4)),
          submit: "insert",
        });
  };
  const fetchPatientType = (event) =>{
  console.log(event.target.value);
  let imageType = event.target.value == "Male"  ? "avatarMaleIcon" : "avatarFemaleIcon";
  console.log(imageType);
  setpatientType(imageType)
  }
  const onEditProduct = (record) => {
    setsubmitType("update");
    console.log(submitType,record);
    showLargeDrawer();
    let response = dataSource.filter((list)=>{return list.code == record.code});
    console.log(response[0]);
      form.setFieldsValue({
        patientid: record.code,
        name: response[0].patientname,
        mobile: response[0].mobile,
        email: response[0].email,
        pincode: response[0].pincode,
        address: response[0].street,
        district: response[0].district,
        state: response[0].state,
        gender: response[0].gender,
        date:response[0].date,
        time:response[0].time,
        openingstock: response[0].openingstock,
        submit: "update",
      });
      setpatientType(response[0].gender == 'Male' ? 'avatarMaleIcon' : 'avatarFemaleIcon');
  };
  const profile = window.sessionStorage.getItem("profile");
  const fetch_profile_permission = (profile) =>{
    console.log('profile',profile);
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
        let dataObj = {};
        response.data.map((list)=>{
          let permissionObj = {};
          if(list.filename == 'masterpatient'){
          permissionObj['add']      = list.add;
          permissionObj['edit']     = list.edit;
          permissionObj['delete']   = list.delete;
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          permissionObj['excel']    = list.excel;
          permissionObj['profile']  = list.profile;
          dataObj[list.filename]    =  permissionObj;
          setUserSetting(permissionObj);
          }
        })
       
       console.log('dataObj',dataObj);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
        console.log(error);
      });
    }
  useEffect(() => {
    fetch_profile_permission(profile);
    fetchTableData();
  }, []);
  const columns = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "sno",
      sorter: (record1, record2) => {
        return record1.id > record2.id;
      },
    },
    {
      key: "2",
      title: "Patient Id",
      dataIndex: "code",
    },
    {
      key: "3",
      title: "Patient Name",
      dataIndex: "patientname",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              autocomplete="off"
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.patientname.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "4",
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      key: "5",
      title: "Gender",
      dataIndex: "gender",
    },
    {
      key: "6",
      title: "Edit",
      render: (record) => (
      Number(userSetting.edit) == 1 ?  <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            onEditProduct(record);
          }}
        >
          <EditFilled />
        </Button> : ''
      ),
    },
    // {
    //   key: "8",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];
  return (
    <>
      <Space>
        { Number(userSetting.add) == 1 ? <Button type="primary" onClick={addProduct}>
          Add Patient +
        </Button> : '' }
      </Space>
      <Modal
        title={submitType == "insert" ? "Add patient" : "Edit patient"}
        style={{ top: 20 }}
        visible={visible}
        onOk={() => drawerClose()}
        onCancel={() => drawerClose()}
        width={"90vw"}
        maskClosable={false}
        footer={null}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={24}>
            <Col span={16}>
            <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="patientid"
                label="patientId"
                //rules={[{ required: false, message: "Please enter user name" }]}
              >
                <Input autocomplete="off" placeholder="Please patient Id" disabled={true} style={{color:"red"}}/>
              </Form.Item>
            </Col>
            <Col span={12}>
           
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: false, message: "Please enter Name" }]}
              >
                <Input autocomplete="off" placeholder="Please patient Name" />
              </Form.Item>
              </Col>
            
              <Form.Item
                name="date"
                label="Name"
                style={{display:"none"}}
                rules={[{ required: false, message: "Please enter Name" }]}
              >
                <Input autocomplete="off" placeholder="Please patient Name" />
              </Form.Item>
              <Form.Item
                name="time"
                label="Name"
                style={{display:"none"}}
                rules={[{ required: false, message: "Please enter Name" }]}
              >
                <Input autocomplete="off" placeholder="Please patient Name" />
              </Form.Item>
          </Row>
          <Row gutter={24}>
          <Col span={12}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[
                  { required: false, message: "Please enter Gender" },
                ]}
              >
                <Radio.Group onChange={fetchPatientType}>
                  <Radio value="Male">Male</Radio>
                  <Radio value="Female">Female</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="mobile"
                label="Mobile"
                rules={[
                  { required: false, message: "Please enter Mobile" },
                  //{ min: 10, message: "Enter Valid Moile Number" },
                ]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Moible"
                ></Input>
              </Form.Item>
                  <Form.Item
                name="submit"
                label="sumit"
                value={submitType}
                rules={[{ required: false }]}
                hidden={true}
              >
                <Input placeholder="Submit" autocomplete="off" />
              </Form.Item>
            </Col>
           </Row>
           <Row gutter={24}>
            <Col span={12}>
            <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: false, message: "Please enter Email" },
                  //{ min: 10, message: "Enter Valid Moile Number" },
                ]}
              >
                <Input
                  autocomplete="off"
                  placeholder="Please Enter Email"
                ></Input>
                </Form.Item>
            </Col>
             
           </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {submitType == "insert" ? "Submit" : "Update"}
            </Button>
          </Form.Item>
            </Col>
            <Col span={8}>
            <div class={patientType}></div>
            </Col>
          </Row>
          
        </Form>
      </Modal>
      <Table
        bordered
        className="tableData"
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 5, total: { totalRecord } }}
      ></Table>
    </>
  );
});
export default Masterpatient;
